import React from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import { App } from './App.jsx';
import { GuestShare } from './GuestShare.jsx';
import { initViewport } from './ios/viewport.js';
import './theme.css';

initViewport();
registerSW({ immediate: true });

const root = createRoot(document.getElementById('root')!);
const sharePath = window.location.pathname.startsWith('/share/')
  ? decodeURIComponent(window.location.pathname.slice('/share/'.length))
  : null;

root.render(
  <React.StrictMode>
    {sharePath ? <GuestShare token={sharePath} /> : <App />}
  </React.StrictMode>,
);
